import { __rest } from "tslib";
import React, { useState, useEffect, useMemo } from 'react';
import { Select } from 'antd';
import cls from 'classnames';
import { omit } from 'lodash';
import { prefixCls } from './type';
import { Loading, NotFound, Search, DownArrow, UpArrow, Close } from './icons';
import './enhanceSelect.scss';
const { Option } = Select;
const Component = (props, ref) => {
    const { showSearch, onFocus, onBlur, showArrow, suffixIcon, size, className, fetching, dropdownClassName, onClick, onDropdownVisibleChange } = props;
    const [focus, setFocus] = useState(false);
    const [downArrow, setDownArrow] = useState(true);
    const handleOnFocus = () => {
        setFocus(!onFocus);
        onFocus && onFocus();
    };
    const handleBlur = () => {
        setFocus(false);
        onBlur && onBlur();
    };
    const notFound = useMemo(() => {
        if (fetching)
            return (React.createElement("div", { className: `${prefixCls}-loading` },
                React.createElement(Loading, null)));
        else
            return React.createElement(NotFound, null);
    }, []);
    const renderSuffixIcon = useMemo(() => {
        if (suffixIcon)
            return suffixIcon;
        else
            return showSearch && focus ? React.createElement(Search, null) : downArrow ? React.createElement(DownArrow, null) : React.createElement(UpArrow, null);
    }, [showSearch, focus, downArrow]);
    useEffect(() => {
        setDownArrow(!focus);
    }, [focus]);
    const handleOnDropdownVisibleChange = (open) => {
        onDropdownVisibleChange && onDropdownVisibleChange(open);
    };
    return (React.createElement(Select, Object.assign({ ref: ref, dropdownClassName: cls(dropdownClassName, `${prefixCls}`), className: cls(className, `${prefixCls}`, `${prefixCls}-${size}`), showArrow: showArrow, suffixIcon: renderSuffixIcon, clearIcon: React.createElement(Close, null), onFocus: handleOnFocus, onBlur: handleBlur, onClick: event => {
            onFocus && onFocus();
            onClick && onClick(event);
        }, showSearch: showSearch, notFoundContent: notFound, onDropdownVisibleChange: handleOnDropdownVisibleChange }, omit(props, [
        'className',
        'showArrow',
        'suffixIcon',
        'onFocus',
        'onBlur',
        'showSearch',
        'size',
        'notFoundContent',
        'clearIcon',
        'dropdownClassName',
        'onClick',
        'onDropdownVisibleChange',
        'fetching',
    ])), renderEnhanceOption(props)));
};
const renderEnhanceOption = (props) => {
    return (React.createElement(React.Fragment, null, React.Children.map(props.children, child => {
        if (!React.isValidElement(child)) {
            return null;
        }
        if (child.type === EnhanceSelect.OptGroup) {
            const optGroupChildElment = child;
            return React.cloneElement(React.createElement(EnhanceSelect.OptGroup, Object.assign({}, optGroupChildElment.props), renderEnhanceOption(Object.assign(Object.assign({}, props), { children: optGroupChildElment.props.children }))));
        }
        const childElement = child;
        const _a = childElement.props, { value, children } = _a, rest = __rest(_a, ["value", "children"]);
        const title = typeof children === 'string' ? children : '';
        return React.cloneElement(React.createElement(Option, Object.assign({ name: children, title: title, value: value }, rest), childElement));
    })));
};
const SelectRef = React.forwardRef(Component);
const EnhanceSelect = SelectRef;
EnhanceSelect.defaultProps = {
    showSearch: false,
    size: 'small',
    showArrow: true,
};
EnhanceSelect.OptGroup = Select.OptGroup;
export default EnhanceSelect;
